import React from 'react';
import { Button, CircularProgress, Grid, Modal, Typography } from '@mui/material';
import { COLOR_ERROR, COLOR_SUCCESS } from 'src/colors';

const PaymentFulfillmentCheckModal = ({
  open,
  setOpen,
  matches,
  status,
  successMessage,
  failureMessage,
}) => {
  const handleModalOnClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Grid
        container
        direction="column"
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          height: matches ? '400px' : '300px',
          position: 'relative',
          width: matches ? '80%' : '30%',
          minWidth: '300px',
          padding: '25px 50px',
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ height: '100%' }}
          item
          xs={12}
        >
          {status == 'loading' && <CircularProgress sx={{ marginBottom: 2 }} />}
          {status == 'loading' && (
            <Typography sx={{ fontWeight: 500, fontSize: 20 }}>Validating payment...</Typography>
          )}

          {status == 'success' && (
            <Typography
              sx={{ fontWeight: 500, fontSize: 20, color: COLOR_SUCCESS, marginBottom: 2 }}
            >
              Payment Successfull!🎉
            </Typography>
          )}
          {status == 'success' && (
            <Typography variant="body1" textAlign="center">
              {successMessage}
            </Typography>
          )}

          {status == 'failed' && (
            <Typography sx={{ fontWeight: 500, fontSize: 20, color: COLOR_ERROR, marginBottom: 2 }}>
              Payment Failed 😔
            </Typography>
          )}
          {status == 'failed' && (
            <Typography variant="body1" textAlign="center">
              {failureMessage}
            </Typography>
          )}

          {status != 'loading' && (
            <Button
              variant="contained"
              sx={{ color: 'white', marginTop: 2 }}
              onClick={() => handleModalOnClose()}
            >
              Understood
            </Button>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default PaymentFulfillmentCheckModal;
